import { Component } from "vue";

export default [
  { path: "", redirect: { name: "fundRaising" }, name: "invest" },
  {
    path: "projects",
    redirect: { name: "fundRaisingLoan" },
  },
  {
    path: "fund-raising-projects",
    component: (): Promise<Component> =>
      import("../components/FundRaising.vue"),
    name: "fundRaising",
    meta: { withSubMenu: true },
  },
  {
    path: "projects/:uuid",
    component: (): Promise<Component> =>
      import("../components/PrimaryMarketProject.vue"),
    name: "primaryMarketProject",
  },
  {
    path: "offers",
    component: (): Promise<Component> =>
      import("../components/SecondaryMarket.vue"),
    name: "secondaryMarket",
    meta: { withSubMenu: true },
  },
  {
    path: "buy-back",
    component: (): Promise<Component> =>
      import("../components/BuyBackOffers.vue"),
    name: "buyBackOffers",
    meta: { withSubMenu: true },
  },
  {
    path: "confirmation/:confirmationUuid",
    component: (): Promise<Component> =>
      import("../components/SignDocumentsPage.vue"),
    name: "signDocuments",
  },
  {
    path: "offers/:uuid",
    component: (): Promise<Component> => import("../components/Offer.vue"),
    name: "secondaryMarketOffer",
  },
  {
    path: "buy-back/:uuid",
    component: (): Promise<Component> => import("../components/Offer.vue"),
    name: "buyBackOffer",
  },
  {
    path: "offers/:uuid/confirmation/:confirmationUuid",
    component: (): Promise<Component> =>
      import("../components/PurchaseConfirmationPrimary.vue"),
    name: "purchaseConfirmation",
  },
  {
    path: "buy-back/:uuid/confirmation/:confirmationUuid",
    component: (): Promise<Component> =>
      import("../components/PurchaseConfirmationBuyBack.vue"),
    name: "purchaseByBackConfirmation",
  },
  {
    path: "fund-raising-loan",
    component: (): Promise<Component> =>
      import("../components/FundRaisingLoan.vue"),
    name: "fundRaisingLoan",
    meta: { withSubMenu: true },
  },
];
